import { render, staticRenderFns } from "./openInvoice.vue?vue&type=template&id=5506a004&scoped=true&"
import script from "./openInvoice.vue?vue&type=script&lang=js&"
export * from "./openInvoice.vue?vue&type=script&lang=js&"
import style0 from "./openInvoice.vue?vue&type=style&index=0&id=5506a004&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5506a004",
  null
  
)

export default component.exports